import { useParams, useSearchParams } from 'react-router-dom';
import { Badge, Container, Row } from 'react-bootstrap';
import { FaPercent } from 'react-icons/fa';
import { useSelector } from 'react-redux';

import Message from '../../components/layout/Message';
import Meta from '../../components/layout/Meta';
import ProductCard from '../../components/product/ProductCard';
import ProductCardSkeleton from '../../components/ui/ProductCardSkeleton';
import Paginate from '../../components/ui/Paginate';
import SortSelect from '../../components/ui/SortSelect';
import { useGetDiscountedProductsQuery } from '../../slices/productApiSlice';

const DiscountProductsScreen = () => {
    const { pageNumber } = useParams();
    const { userInfo } = useSelector((state) => state.auth);

    const [searchParams] = useSearchParams();
    const sort = searchParams.get('sort') || '';
    const page = pageNumber || 1;

    const { data, isLoading, isFetching, error } = useGetDiscountedProductsQuery({
        pageNumber: page,
        priceAssigned: userInfo?.priceAssigned || null,
        sort,
    });

    const products = data || data?.products || [];

    return (
        <Container className="py-4">
            <Meta title="Descuentos" />

            <div id="discount-products-section" className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4 p-3 p-md-4 border rounded-4 bg-light">
                <div className="d-flex align-items-center gap-3 flex-grow-1">
                    <div
                        className="d-flex align-items-center justify-content-center rounded-3"
                        style={{
                            width: '64px',
                            height: '64px',
                            backgroundColor: '#fff5f2',
                            color: '#b5430f',
                            border: '1px solid #f2d6cb',
                        }}
                    >
                        <FaPercent size={24} />
                    </div>
                    <div>
                        <p className="text-muted mb-1 small">Promociones activas</p>
                        <h1 className="mb-1 section-title">Productos con descuento</h1>
                        <Badge bg="light" text="dark" className="border">
                            Mejores precios disponibles hoy
                        </Badge>
                    </div>
                </div>
                <div style={{ minWidth: '200px' }}>
                    <SortSelect currentSort={sort} />
                </div>
            </div>

            {isLoading || isFetching ? (
                <Row className="mx-0">
                  <div className="ProductGrid">
                    {[...Array(8)].map((_, idx) => (
                      <ProductCardSkeleton key={idx} />
                    ))}
                  </div>
                </Row>
            ) : error ? (
                <Message variant="danger">
                    {error?.data?.message || error?.error || 'Ocurrió un error al cargar los descuentos.'}
                </Message>
            ) : (
                <>
                    {products.length === 0 ? (
                        <div className="text-center py-5 bg-light rounded-4 border">
                            <p className="text-muted mb-0">No hay productos con descuento disponibles en este momento.</p>
                        </div>
                    ) : (
                        <>
                            <Row className="mx-0">
                                <div className="ProductGrid">
                                    {products.map((product) => (
                                        <ProductCard product={product} key={product._id} />
                                    ))}
                                </div>
                            </Row>
                            <div className="mt-4">
                                <Paginate pages={data.pages} page={data.page} sort={sort} isDiscounts scrollTargetId="discount-products-section" />
                            </div>
                        </>
                    )}
                </>
            )}
        </Container>
    );
};

export default DiscountProductsScreen;
